<ion-row class="ion-no-padding">
  <ion-col id="left-col" *ngIf="(constraints$ | async).width > 575">
    <ng-container
      *ngFor="
        let item of sidebarItems | slice : 0 : sidebarItems.length / 2;
        let i = index;
        trackBy: studioButtonTrackBy
      ">
      <sc-studio-controls-button
        [sidebar]="item"
        [index]="i"
        (pointerdown)="pointerDown($event)"
        (pointerup)="pointerUpLeave($event)"
        (pointerleave)="pointerUpLeave($event)"
        (mouseleave)="pointerUpLeave($event)"></sc-studio-controls-button>
    </ng-container>
  </ion-col>

  <ion-col id="center-col">
    <ion-button
      *ngIf="(role$ | async) >= roleLimits.MICROPHONE_UPDATE && !backstage"
      (click)="toggleMute()"
      [tooltip]="((mute$ | async) ? 'Unmute' : 'Mute') + ' Microphone (Ctrl + D)'"
      aria-label="Toggle Microphone (Ctrl + D)"
      class="text"
      size="large">
      <ion-icon
        [src]="(mute$ | async) ? '/assets/icons/32px/mic-off-bold.svg' : '/assets/icons/32px/mic-bold.svg'"
        slot="icon-only">
      </ion-icon>
    </ion-button>

    <!-- [disabled]="disableCameraToggle || !videoPermission" -->
    <ion-button
      *ngIf="(role$ | async) >= roleLimits.CAMERA_UPDATE && !backstage"
      (click)="toggleVideoOff()"
      [tooltip]="((videoOff$ | async) ? 'Show' : 'Hide') + ' Camera (Ctrl + E)'"
      [disabled]="!videoPermission || disableCameraToggle"
      aria-label="Toggle Camera (Ctrl + E)"
      class="text"
      size="large">
      <ion-icon
        [src]="(videoOff$ | async) ? '/assets/icons/32px/video-off-bold.svg' : '/assets/icons/32px/video-bold.svg'"
        slot="icon-only">
      </ion-icon>
    </ion-button>

    <ion-button
      (click)="toggleRecording()"
      *ngIf="(role$ | async) >= roles.GUEST && (recording$ | async) !== true"
      [tooltip]="recordButtonState.message"
      aria-label="Start Recording (Ctrl + R)"
      class="text"
      id="studio-controls-record-button"
      [class.record-button]="true"
      [class.stop-button]="false"
      [class.disabled]="recordButtonState.disabled"
      size="large">
      <ion-icon src="/assets/icons/32px/record-outline-bold.svg" slot="icon-only"> </ion-icon>
    </ion-button>

    <ion-button
      (click)="toggleRecording()"
      *ngIf="(role$ | async) >= roles.GUEST && (recording$ | async) === true"
      [tooltip]="recordButtonState.message"
      aria-label="Stop Recording (Ctrl + R)"
      class="text"
      id="studio-controls-record-button"
      [class.record-button]="false"
      [class.stop-button]="true"
      [class.disabled]="recordButtonState.disabled"
      size="large">
      <ion-icon src="/assets/icons/24px/stop-solid.svg" slot="icon-only"> </ion-icon>
    </ion-button>

    <ion-button
      *ngIf="(role$ | async) >= roleLimits.CAMERA_UPDATE && !backstage"
      (click)="toggleScreenShare()"
      [tooltip]="
        ((dolbyScreenshare$ | async) || (dailyScreenshare$ | async) ? 'Stop' : 'Start') + ' Screen Share (Ctrl + S)'
      "
      aria-label="Share Screen (Ctrl + S)"
      [disabled]="isMobile"
      class="text"
      [class.active-button]="false"
      size="large">
      <ion-icon
        [src]="
          (dolbyScreenshare$ | async) || (dailyScreenshare$ | async)
            ? '/assets/icons/32px/screenshare-off-bold-2.svg'
            : '/assets/icons/32px/screenshare-bold.svg'
        "
        slot="icon-only">
      </ion-icon>
    </ion-button>

    <ion-button
      *ngIf="(role$ | async) >= roleLimits.CAMERA_UPDATE"
      tooltip="Take SquadShot (Ctrl + G)"
      aria-label="Take SquadShot (Ctrl + G)"
      class="text"
      id="studio-controls-squadshot-button"
      [class.active-button]="false"
      size="large"
      (click)="takeSquadshot()">
      <ion-icon src="/assets/icons/32px/camera-bold.svg" slot="icon-only"> </ion-icon>
    </ion-button>
  </ion-col>

  <ion-col id="right-col" *ngIf="(constraints$ | async).width > 575">
    <ng-container
      *ngFor="
        let item of sidebarItems | slice : sidebarItems.length / 2 : sidebarItems.length;
        let i = index;
        trackBy: studioButtonTrackBy
      ">
      <sc-studio-controls-button
        [sidebar]="item"
        [index]="i + sidebarItems.length / 2"
        (pointerdown)="pointerDown($event)"
        (pointerup)="pointerUpLeave($event)"
        (pointerleave)="pointerUpLeave($event)"
        (mouseleave)="pointerUpLeave($event)"></sc-studio-controls-button>
    </ng-container>
  </ion-col>
</ion-row>

<ion-row class="ion-no-padding sc-color-light-light-mode-bg" *ngIf="(constraints$ | async).width <= 575">
  <ion-col id="center-col" class="ion-no-padding">
    <ng-container *ngFor="let item of sidebarItems; let i = index; trackBy: studioButtonTrackBy">
      <sc-studio-controls-button
        [sidebar]="item"
        [index]="i"
        size="small"
        (pointerdown)="pointerDown($event)"
        (pointerup)="pointerUpLeave($event)"
        (pointerleave)="pointerUpLeave($event)"
        (mouseleave)="pointerUpLeave($event)"></sc-studio-controls-button>
    </ng-container>
  </ion-col>
</ion-row>
